import React, { useState } from "react";
import Typography from "@mui/material/Typography";
import Slider from "@mui/material/Slider";
import axios from "axios";
import { apiCall_domain } from "../api";
import { createGlobalStyle } from "styled-components";
import Header from "../header";
import useSimpleReactValidator from "../../Hooks/useSimpleReactValidator";
import ImageDropzone from "../global/ImageDropzone";

const AddCommentDashboard = (props) => {
  const [activeClass, setActiveClass] = useState();
  const [state, setState] = useState({
    advantages: [],
    disAdvantages: [],
    images: [],
  });
  const [images, setImages] = useState([]);
  const [rate, setRate] = useState();
  const [advantage, setAdvantage] = useState();
  const [disAdvantage, setDisAdvantage] = useState();
  const [uploadImages, setUploadImages] = useState([]);
  const [validator, forceUpdate] = useSimpleReactValidator({
    className: "danger addCommentReq",
    messages: { required: "این فیلد نباید خالی باشد" },
    autoForceUpdate: true,
    validators: {
      fileSize: {
        message: "فایل انتخاب شده نباید بیشتر از 1 مگابایت باشد",
        rule: (files, params, validators) => {
          for (let i = 0; i < files.length; i++) {
            if (files[i].size / 1024 > 1024) {
              return false;
            }
          }
          return true;
        },
      },
      fileCount: {
        message: "حداکثر میتوانید 3 عکس انتخاب کنید",
        rule: (files, params, validators) => {
          if (
            files.length > 3 ||
            state.images.length > 3 ||
            state.images.length + files.length > 3
          ) {
            return false;
          }
          return true;
        },
      },
    },
  });
  const handleChange = (event, newValue) => {
    setRate(newValue);
  };
  const setValues = (event) => {
    setState({ ...state, [event.target.name]: event.target.value });
  };

  const handleAdvantages = (e) => {
    setAdvantage(e.target.value);
  };

  const handleDisAdvantages = (e) => {
    setDisAdvantage(e.target.value);
  };

  const addAdvantages = () => {
    if (advantage !== "") {
      let newState = state.advantages;
      newState.push(advantage);
      setState({ ...state, advantages: newState });
      setAdvantage("");
    }
  };

  const addDisAdvantages = () => {
    if (disAdvantage !== "") {
      let newState = state.disAdvantages;
      newState.push(disAdvantage);
      setState({ ...state, disAdvantages: newState });
      setDisAdvantage("");
    }
  };

  const removeAdvantage = (name) => {
    const newState = state.advantages;
    const selected = newState.filter((names) => names !== name);
    setState({ ...state, advantages: selected });
  };

  const removeDisAdvantage = (name) => {
    const newState = state.disAdvantages;
    const selected = newState.filter((names) => names !== name);
    setState({ ...state, disAdvantages: selected });
  };

  const classTagler = (number) => {
    setActiveClass(number);
  };
  const GlobalStyles = createGlobalStyle`body{
      background: #fafafa !important;
    }`;

  const headers = {
    Authorization: localStorage.getItem("Api_key"),
  };

  const uploadFile = (file) => {
    const formData = new FormData();
    formData.append("file", file);
    return axios.post(`${apiCall_domain}/customer/store-file`, formData, {
      headers: headers,
    });
  };
  const uploadImage = () => {
    return new Promise((resolve, reject) => {
      images.map(async (image) => {
        await uploadFile(image).then((res) => {
          const tempUploadedImages = uploadImages;
          tempUploadedImages.push(res.data.name);
          setUploadImages(tempUploadedImages);
          if (images.length === tempUploadedImages.length) {
            resolve();
          }
        });
      });
    });
  };

  const submit = async () => {
    validator.showMessages();
    if (validator.allValid) {
      const submitComment = (orderId, vendorItemId, data) => {
        return axios.post(
          `${apiCall_domain}/customer/user/rate/${orderId}`,
          data,
          { headers },
        );
      };
      const Data = {
        rate: rate,
        is_recommended: activeClass,
        item_id: props.match.params.item_id,
        details: {
          title: state.title,
          text: state.text,
          advantages: state.advantages,
          disadvantages: state.disAdvantages,
        },
      };
      if (images.length) {
        await uploadImage().then((res) => {});
        Data["images"] = uploadImages;
        submitComment(
          props.match.params.order_id,
          props.match.params.item_id,
          Data,
        ).then((res) => props.history.goBack());
      } else {
        submitComment(
          props.match.params.order_id,
          props.match.params.item_id,
          Data,
        ).then((res) => props.history.goBack());
      }
    }
  };
  return (
    <>
      <GlobalStyles />
      <Header showSearchBar={true} title="دیدگاه شما" />
      <main>
        <div className="addNewComment">
          <div className="Typography">
            <Typography id="non-linear-slider" gutterBottom>
              به محصول امتیاز دهید
            </Typography>
            <Slider
              min={0}
              name="rate"
              max={5}
              defaultValue={0}
              aria-label="Default"
              valueLabelDisplay="auto"
              value={rate}
              onChange={handleChange}
            />
            {validator.message("rate", rate, "required")}
          </div>
          <div className="ProposalComment">
            <p>آیا این محصول را برای خرید پیشنهاد میکنید؟</p>
            <div className="CommentBody">
              <div
                className={`Content like ${
                  activeClass == 0 ? "activeClass" : ""
                } `}
                onClick={() => classTagler(0)}
                value={0}
              >
                <div className="Image">
                  <i className="icon-liken" />
                </div>
                <span>پیشنهاد میکنم</span>
              </div>
              <div
                className={`Content notsure ${
                  activeClass == 1 ? "activeClass" : ""
                } `}
                onClick={() => classTagler(1)}
                value={1}
              >
                <div className="Image">
                  <i className="icon-wo" />
                </div>
                <span>مطمئن نیستم</span>
              </div>
              <div
                className={`Content dislike ${
                  activeClass == 2 ? "activeClass" : ""
                } `}
                onClick={() => classTagler(2)}
                value={2}
              >
                <div className="Image">
                  <i className="icon-dislik" />
                </div>
                <span>پیشنهاد نمی کنم</span>
              </div>
            </div>
            {validator.message("activeClass", activeClass, "required")}
          </div>
          <div className="ProductCm">
            <p>محصول از دیدگاه شما:</p>
            <span>عنوان دیدگاه</span>
            <input
              onChange={(e) => setValues(e)}
              placeholder="چه عنوانی به دیدگاه خود می دهید؟"
              className="InputTaitle"
              name="title"
            />
            {validator.message("title", state.title, "required")}
            <span>نکات مثبت محصول</span>
            <div className="TextPositive">
              <input
                onChange={handleAdvantages}
                className="InputPositive"
                name="positiveText"
                value={advantage}
              />
              <span
                className="SymbolPositive"
                onClick={() => {
                  addAdvantages();
                }}
              >
                &#10011;
              </span>
              <div className="advantageShowSection">
                {state.advantages
                  ? state.advantages.map((advantage) => (
                      <div className="positiveComment">
                        <span
                          className="crossPositive"
                          onClick={() => removeAdvantage(advantage)}
                        >
                          &#9587;
                        </span>
                        {advantage}
                      </div>
                    ))
                  : null}
              </div>
            </div>
            <span>نکات منفی محصول</span>
            <div className="TextNegative">
              <input
                onChange={handleDisAdvantages}
                className="InputNegative"
                name="negetiveText"
                value={disAdvantage}
              />
              <span
                className="SymbolPositive"
                onClick={() => {
                  addDisAdvantages();
                }}
              >
                &#10011;
              </span>
              <div className="advantageShowSection">
                {state.disAdvantages
                  ? state.disAdvantages.map((disAdvantage) => (
                      <div className="negetiveComment">
                        <span
                          onClick={() => {
                            removeDisAdvantage(disAdvantage);
                          }}
                          className="crossNegetive"
                        >
                          &#9587;
                        </span>
                        {disAdvantage}
                      </div>
                    ))
                  : null}
              </div>
            </div>
            <div className="Text">
              <span>متن نظر</span>
              <span className="SymbolStar">&#10038;</span>
            </div>
            <textarea
              name="text"
              onChange={(e) => setValues(e)}
              className="textarea"
              placeholder="متن نظر خود را بنویسید"
              rows="8"
              cols="50"
            ></textarea>
            {validator.message("text", state.text, "required")}
          </div>
          <div className="Upload">
            <p className="Text">آپلود مدیا</p>
            <span>حداکثر ۳ عکس ۱ مگابایت </span>
            <ImageDropzone onChange={setImages} />
            {validator.message("fileData", images, "fileCount|fileSize")}
          </div>
          <button onClick={() => submit()} className="Button">
            ثبت دیدگاه
          </button>
        </div>
      </main>
    </>
  );
};
export default AddCommentDashboard;
